import React from "react";

const TONE_STYLES = {
    error: "border-red-200 bg-red-50 text-red-700",
    info: "border-sky-200 bg-sky-50 text-sky-800",
    success: "border-emerald-200 bg-emerald-50 text-emerald-800",
    warning: "border-amber-200 bg-amber-50 text-amber-800",
};

export default function AuthAlert({ tone = "error", title, children, live = "polite" }) {
    return (
        <div
            className={`rounded-2xl border px-4 py-3 text-sm ${TONE_STYLES[tone] || TONE_STYLES.info}`}
            role={tone === "error" ? "alert" : "status"}
            aria-live={live}
        >
            {title ? <p className="font-semibold">{title}</p> : null}
            <p className={title ? "mt-1 leading-6" : "leading-6"}>{children}</p>
        </div>
    );
}
